import React from 'react';
import reactDom from '../../../../common/react/dom/index';
import CartFailed from '../../../../components/frontend/cart/failed';

export default function init() {
	reactDom(<CartFailed />, 'js-react-failedorder');
}
